/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from "../ComponentBase";
import MutatorComponentBase from "./Mutator/MutatorComponentBase";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class SceneDebugger extends MutatorComponentBase
{
    private _button: cc.Button = null;

    protected onLoad(): void
    {
        super.onLoad();

        this._button = this.getComponent(cc.Button);

        if (!this._button)
        {
            this.enabled = false;
            return;
        }

        this.AddComponentEventHandler(
            SceneDebugger.name,
            'button-click',
            () => this.onClickHandler(),
            this._button.clickEvents
        );
    }

    private onClickHandler(): void
    {
        cc.director.getScene().children.forEach(child =>
        {
            this.applyNodeRecursively(child, [(target: cc.Node) =>
            {
                this.log(
                    target,
                    `Components: ${JSON.stringify(target.getComponents(cc.Component).map(c => c.constructor.name))}`
                );
                return true;
            }]);
        }, this);
    }

    protected log(target: cc.Node, message: string): void
    {
        cc.log(`${target.name} - ${message}`);
    }
}
